<div class="card" *ngIf="avisosAnalise">
    <div class="card-header">
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6>Comentários da Análise</h6>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card" *ngFor="let analise of avisosAnalise">
            <p>{{analise.mensagem}}</p>
        </div>
    </div>
</div>
<div class="card" *ngIf="avisosProtocolo">
    <div class="card-header">
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6>Observação (Protocolo)</h6>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card" *ngFor="let protocolo of avisosProtocolo">
            <p>{{protocolo.mensagem}}</p>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">Histórico</h6>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card ps-3 pt-3 pe-3">
            <div class="table-responsive">
                <table class="table table-hover table-sm table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Data</th>
                            <th scope="col">Evento</th>
                            <th scope="col">Responsável</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let h of historicos">
                            <td>{{h.dataEvento | date: 'dd/MM/yyyy'}}</td>
                            <td>{{h.evento}}</td>
                            <td>{{h.responsavel}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>